var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          ref: "quizbody",
          style:
            _vm.question && _vm.question.image != ""
              ? {
                  "background-image": "url(" + _vm.question.image + ")",
                  "background-size": "cover",
                }
              : "",
          attrs: { id: "mainQWrap" },
        },
        [
          _c("smallloader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.smallloader && !_vm.error,
                expression: "smallloader && !error",
              },
            ],
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.question && _vm.question.renderTemplate === "Template1"
                ? [_c("Q1Template")]
                : _vm.question && _vm.question.renderTemplate === "Template2"
                ? [_c("Q2Template")]
                : _vm.question && _vm.question.renderTemplate === "Template3"
                ? [_c("Q3Template")]
                : _vm.question && _vm.question.renderTemplate === "Template4"
                ? [_c("Q4Template")]
                : _vm.question && _vm.question.renderTemplate === "Template5"
                ? [_c("Q5Template")]
                : _vm.question && _vm.question.renderTemplate === "Template6"
                ? [_c("Q6Template")]
                : _vm.question && _vm.question.renderTemplate === "Template7"
                ? [_c("Q7Template")]
                : _vm.question && _vm.question.renderTemplate === "Template8"
                ? [_c("Q8Template")]
                : _vm.question &&
                  _vm.question.renderTemplate === "Template9" &&
                  _vm.isVisible
                ? [_c("Q9Template")]
                : _vm.question && _vm.question.renderTemplate === "Template10"
                ? [_c("Q10Template")]
                : [_c("Q1Template")],
              _vm._v(" "),
              _c("navbuttons"),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }